export enum FormId {
  GENERAL_PROFILE = 'general-profile',
  NOTIFICATION_PREFERENCES = 'notification-preferences',
  AUTH_REGISTRATION = 'auth-registration',
  AUTH_PROFILE_IMAGES = 'auth-profile-images',
  ADD_LOCATION = 'add-location',
  EDIT_LOCATION = 'edit-location',
  ADD_COMMENT = 'add-comment',
  EDIT_GAMBIT = 'edit-gambit',
  ADD_CLUB = 'add-club',
  EDIT_CLUB = 'edit-club',
  EDIT_CLUB_ORGANIZERS = 'edit-club-organizers',
  ADD_REPORT = 'add-report',
}
